import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import { EInternalUserType } from '../../utils/constants';

export const COL_NAMES = {
	oe: 'oe',
	e: 'e',
	et: 'et',
	ut: 'ut',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Official Email',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.oe]
	}),
	StringColumn({
		title: 'Phone/Email',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.e]
	}),
	StringColumn({
		title: 'Entity Type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.et]
	}),
	StringColumn({
		title: 'User Type',
		maxWidth: 300,
		mapDataToValue: (data: any) => EInternalUserType[data[COL_NAMES.ut]] || EMPTY_STRING
	})
];

export const activeFilter = [];
